import React, { useContext, useEffect, useState } from "react";
import styled from "styled-components";
import { TitleText } from "../../ui/Text";
import { Button } from "../../ui/Button";
import { Timeline } from "./Timeline";
import { TaskList } from "./TaskList";
import { Field, Formik } from "formik";
import { GetHook, putEndpoint } from "../../api/api";
import { TASKS_URL } from "../../api/urls";
import DateRangePicker2 from "../../ui/DateRangePicker";
import { get } from "../../utils/get";
import moment from "moment";
import { AuthContext } from "../../context/AuthContext";
import Axios from "../../utils/axios";
import { useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import { TimelineTaskInfoSubject } from "../../subjects/TimelineTaskInfoSubject";
import { AddInitiative } from "../plan/AddInitiative";
import Modal from "../../ui/Modal";
import { ReloadPlanSubject } from "../../subjects/ReloadPlanSubject";

export const Timeboard = () => {
  const [dateFilter, setDateFilter] = useState("");
  const [filter, setFilter] = useState({});
  const [tasks, setTasks] = useState([]);
  const auth = useContext(AuthContext);
  const [updateRes, updateTask] = putEndpoint();
  const [isModalOpen, setisModalOpen] = useState(false);

  const location = useLocation();

  const { user } = get(auth, "authState");
  const date =
    get(dateFilter, "startDate") && get(dateFilter, "endDate")
      ? `interval=${moment(get(dateFilter, "startDate")).format(
          "YYYY-MM-DD"
        )}/${moment(get(dateFilter, "endDate")).format("YYYY-MM-DD")}`
      : "";
  const { data, reload } = GetHook(
    date
      ? `${TASKS_URL}?owner_id=${[
          get(user, "id"),
        ]}&${date}&show_subordinates=true`
      : "null"
  );

  const filterTasks = (url) => {
    Axios.get(url).then((res) => {
      const { returned_resultset } = get(res, "data");
      setTasks(returned_resultset);
    });
  };

  useEffect(() => {
    setTasks(data);
    return () => {};
  }, [data]);

  useEffect(() => {
    const { complete, pending, data, error } = updateRes;
    if (error) {
      toast.error(get(data, "message"));
    }
    if (!pending && complete && !error) {
      toast.success("Task status updated successfully");
      reload(get(location, "key"));
    }
  }, [updateRes]);

  const handleMarkAsComplete = (id) => {
    updateTask(`${TASKS_URL}/${id}/owner/${get(user, "id")}`, {
      status: "complete",
    });
  };

  const handleStatusUpdate = (id, status) => {
    updateTask(`${TASKS_URL}/${id}/owner/${get(user, "id")}`, {
      status: status,
    });
  };

  useEffect(() => {
    if (
      get(filter, "assigned") &&
      get(filter, "created") &&
      get(filter, "status")
    ) {
      filterTasks(
        `${TASKS_URL}?owner_id=${get(user, "id")}&owners=${get(
          filter,
          "assigned"
        )}&created_by=${get(filter, "created")}&owner_task_status=${get(
          filter,
          "status"
        )}&${date}`
      );
    } else if (get(filter, "assigned") && get(filter, "created")) {
      filterTasks(
        `${TASKS_URL}?owner_id=${get(user, "id")}&owners=${get(
          filter,
          "assigned"
        )}&created_by=${get(filter, "created")}&${date}`
      );
    } else if (get(filter, "assigned") && get(filter, "status")) {
      filterTasks(
        `${TASKS_URL}?owners=${get(
          filter,
          "assigned"
        )}&owner_task_status=${get(filter, "status")}&${date}`
      );
    } else if (get(filter, "created") && get(filter, "status")) {
      filterTasks(
        `${TASKS_URL}?owner_id=${get(user, "id")}&created_by=${get(
          filter,
          "created"
        )}&owner_task_status=${get(filter, "status")}&${date}`
      );
    } else if (get(filter, "assigned")) {
      filterTasks(
        `${TASKS_URL}?owners=${get(
          filter,
          "assigned"
        )}&${date}`
      );
    } else if (get(filter, "status")) {
      filterTasks(
        `${TASKS_URL}?owner_id=${get(user, "id")}&owner_task_status=${get(
          filter,
          "status"
        )}&${date}`
      );
    } else if (get(filter, "created")) {
      filterTasks(
        `${TASKS_URL}?owner_id=${get(user, "id")}&created_by=${get(
          filter,
          "created"
        )}&${date}`
      );
    } else {
      setTasks(data);
    }
    return () => {};
  }, [filter, date, data, user]);
  useEffect(() => {
    const planSub = ReloadPlanSubject.subscribe((payload) => {
      if (payload) {
        reload(get(location, "key"));
        ReloadPlanSubject.next(false);
      }
    });
    return () => {
      planSub.unsubscribe();
    };
  }, [get(location, "key"), reload]);
  return (
    <TimeboardContainer>
      {isModalOpen && (
        <Modal
          title="add task"
          noHeader
          noFooter
          closeModal={() => setisModalOpen(false)}
        >
          <AddInitiative
            isOpen={isModalOpen}
            onClick={() => setisModalOpen(false)}
            user={user}
          />
        </Modal>
      )}
      <TimeBoardHeader>
        <TitleText>My Timeboard</TitleText>
        <Formik initialValues={{}} onSubmit={() => console.log("object")}>
          {({ values }) => {
            setDateFilter(get(values, "date_range"));
            return (
              <Field
                name="date_range"
                component={DateRangePicker2}
                backgroundColor="#F5F6FB"
                isClearable={true}
              />
            );
          }}
        </Formik>
        <Button text="New Task" onClick={() => setisModalOpen(true)} />
      </TimeBoardHeader>
      <TimeBoardContent>
        <Timeline
          data={tasks}
          markAsComplete={handleMarkAsComplete}
          setFilter={setFilter}
          filter={filter}
          user={user}
        />
        <TaskList handleStatusUpdate={handleStatusUpdate} />
      </TimeBoardContent>
    </TimeboardContainer>
  );
};

const TimeboardContainer = styled.div`
  display: grid;
  grid-template-rows: 5em auto;
  background-color: #f5f6fb;
  margin-bottom: 1em;
`;
const TimeBoardHeader = styled.div`
  display: grid;
  grid-template-columns: 6fr 4fr 1fr;
  padding: 1em 2em;
  border-bottom: 1px solid #ebeeff;
  align-items: center;
`;

const TimeBoardContent = styled.div`
  background-color: #f5f6fb;
  display: grid;
  grid-template-columns: 1.5fr 1fr;
  grid-column-gap: 2em;
  grid-row-gap: 2em;
  padding: 1em 2em;
`;
